var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-virtual-scroll',{attrs:{"bench":5,"items":_vm.filteredPerson,"height":"inherit","item-height":"140"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('v-card',{staticClass:"employee-item",attrs:{"flat":"","to":("/employee/" + (item.id))}},[_c('employee-row',{attrs:{"employee":item,"photo-filename":_vm.getPhotoFilename(item)}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }